const SNAKE_CASE_CACHE = new Map<string, string>();

function snakeCase(value: string): string {
    let result = SNAKE_CASE_CACHE.get(value);

    if (!result) {
        const chars: string[] = [];

        for (let x = 0; x < value.length; x++) {
            const c = value.charAt(x);

            if (c >= 'A' && c <= 'Z') {
                chars.push('_', c.toLowerCase());
            } else {
                chars.push(c);
            }
        }

        result = chars.join('');
        SNAKE_CASE_CACHE.set(value, result);
    }

    return result;
}

export function snakeCaseObject<T>(data: T): T | object {
    if (typeof data === 'object' && data !== null) {
        return Array.isArray(data)
            ? data.map(snakeCaseObject)
            : Object.fromEntries(Object.entries(data).map(([key, value]) => [snakeCase(key), snakeCaseObject(value)]));
    } else {
        return data;
    }
}
